module.exports = __webpack_public_path__ + "static/media/Roboto-Light.7b5fb88f.ttf";